import React from 'react'

const RightServiceCategoriesSection2 = (props) => {
  return (
    <li className="h-16 cursor-pointer  hover:text-amber-400">
    {" "}
    {props.activity}
  </li>
  )
}

export default RightServiceCategoriesSection2